import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface LgcyLisInputProps {
  onLgcyLisChange: (value: string) => void;
  lgcyLisValue: string;
  isEnabled: boolean;
}

export const LgcyLisInput: React.FC<LgcyLisInputProps> = ({
  onLgcyLisChange,
  lgcyLisValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="LGCY LIS#"
      label="Enter LGCY LIS#:"
      placeholder="Enter LGCY LIS number..."
      value={lgcyLisValue}
      onChange={onLgcyLisChange}
      isEnabled={isEnabled}
    />
  );
};
